import { toast } from "react-toastify";
import isValidEmail from "../../utils/isValidEmail";

const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    items: [],
    subtotal: 0,
    delivery: 0,
    CouponDiscount: 0,
    GrandTotal: 0,
    paymentStatus: 'paid',
    invoice: {
        name: '',
        mobile: "",
        email: "",
        addressFillds: [],
        address: ''
    },
    deliverDifAddress: {
        name: "",
        mobile: "",
        email: "",
        area: "",
        address: ""
    },
    notes: '',
    orderSuccessData: [],
    checkInputValidate: false,
    coupon: {},
    GrandTotalformaintainCoupon: 0
};

const checkoutSlice = createSlice({
    name: "checkout",
    initialState,
    reducers: {
        setAllItemsInCheckout: (state, action) => {
            state.items = action.payload.cartProducts;
            state.subtotal = action.payload.cartTotalAmount;

            state.GrandTotal = Number(action.payload.cartTotalAmount) + state.delivery;
        },
        addPementStatus: (state, action) => {
            state.paymentStatus = action.payload;
        },
        setFromInfo: (state, action) => {
            if ('inname' === action.payload.name) {
                state.invoice.name = action.payload.data;
            }
            if ('inmobile' === action.payload.name) {
                state.invoice.mobile = action.payload.data;
            }
            if ('inemail' === action.payload.name) {
                if (!isValidEmail(action.payload.data)) {
                    toast.error("Email not valid", {
                        position: "bottom-left",
                    });
                    state.invoice.email = "";
                }
                else {
                    state.invoice.email = action.payload.data;
                }
            }
            if ('addressFillds' === action.payload.name) {
                state.invoice.addressFillds = action.payload.data;
                if (action.payload.data[0] === '6 Dhaka') {
                    state.GrandTotal -= state.delivery
                    state.delivery = 45
                    state.GrandTotal += 45
                } else {
                    state.GrandTotal -= state.delivery
                    state.delivery = 80
                    state.GrandTotal += 80
                }

            }
            if ('inaddress' === action.payload.name) {
                state.invoice.address = action.payload.data;
            }
            // ==========================================================

            if ('ddfName' === action.payload.name) {
                state.deliverDifAddress.name = action.payload.data;
            }
            if ('ddfMobile' === action.payload.name) {
                state.deliverDifAddress.mobile = action.payload.data;
            }
            if ('ddfEmail' === action.payload.name) {
                state.deliverDifAddress.email = action.payload.data;
            }
            if ('ddfArea' === action.payload.name) {
                state.deliverDifAddress.area = action.payload.data;
            }
            if ('ddfaddress' === action.payload.name) {
                state.deliverDifAddress.address = action.payload.data;
            }
            if ('notes' === action.payload.name) {
                state.notes = action.payload.data;
            }
        },
        checkValidate: (state, action) => {
            // state.orderSuccessData = action.payload;
            if (!state.invoice.name) {
                state.checkInputValidate = false;
                toast.error("Name* field is required", {
                    position: "bottom-left",
                });
            }
            else if (!state.invoice.mobile) {
                state.checkInputValidate = false;
                toast.error("Mobile* field is required", {
                    position: "bottom-left",
                });
            }
            else if (!state.invoice.email) {
                state.checkInputValidate = false;
                toast.error("Email* field is required", {
                    position: "bottom-left",
                });
            }
            else if (state.invoice.addressFillds === []) {
                state.checkInputValidate = false;
                toast.error("Address selection* field is required", {
                    position: "bottom-left",
                });
            }
            else if (!state.invoice.address) {
                state.checkInputValidate = false;
                toast.error("Address field is required", {
                    position: "bottom-left",
                });
            }
            else {
                state.checkInputValidate = true;
            }
        },
        onCloseModal: (state, action) => {
            state.checkInputValidate = false;
        },
        setCoupon: (state, action) => {

            if (action.payload?.persent) {
                if (state.coupon?.persent) {
                    toast.error("alredy added a coupon", {
                        position: "bottom-left",
                    });

                    return;
                }
                state.coupon = action.payload;
                state.GrandTotalformaintainCoupon = state.GrandTotal;

                let reducerPrice = (state.GrandTotal * Number(state.coupon.persent)) / 100;
                state.GrandTotal -= reducerPrice;
                state.CouponDiscount = reducerPrice;

                toast.success("added a coupon", {
                    position: "bottom-left",
                });
            }
            else {
                toast.error("wrong coupon", {
                    position: "bottom-left",
                });
            }

        }
    },
});

export default checkoutSlice.reducer;
export const { setAllItemsInCheckout, setFromInfo, addPementStatus, checkValidate, onCloseModal, setCoupon } = checkoutSlice.actions;